import { ColorMode, ColorScheme } from './interface';

export const colorScheme: Record<ColorMode, ColorScheme> = {
  light: {
    grid: {
      stroke: 'gray.300',
      strokeWidth: 1,
    },

    xAxis: {
      tick: {
        fill: 'gray.700',
        fontSize: 'sm',
      },
      axisLine: {
        stroke: 'gray.300',
      },
    },
    yAxis: {
      tick: {
        fill: 'gray.500',
        fontSize: '2xs',
      },
      axisLine: {
        stroke: 'gray.300',
      },
    },
    tooltip: {
      color: 'fg.subdued',
      bg: 'bg.subtle/80',
      border: 'gray/30',
      titleColor: 'primary.emphasized',
      valueColor: 'secondary.emphasized',
    },
    legend: {
      fill: 'fg.subdued',
      fontSize: 'xs',
    },
    series: {
      // bar - used in bar charts
      defaultBar: {
        fill: 'terracotta.600',
      },
      activeBar: {
        overlayFill: 'rgba(0, 0, 0, 0.2)', // Semi-transparent overlay on top of original bar
        stroke: 'rgba(0, 0, 0, 0.2)',
        strokeWidth: 5,
      },
      // dot - used in line charts
      defaultLine: {
        stroke: 'gray.600',
        strokeWidth: 1,
      },
      defaultDot: {
        fill: 'terracotta.600',
        stroke: 'none',
        strokeWidth: 0,
      },
      activeDot: {
        stroke: 'gray.800',
        strokeWidth: 3,
      },
      label: {
        position: 'center',
        fill: 'black',
        fontSize: 'xs',
        fontWeight: 'bold',
      },
    },
  },
  dark: {
    grid: {
      stroke: 'gray.700',
      strokeWidth: 1,
    },
    xAxis: {
      tick: {
        fill: 'gray.300',
        fontSize: 'sm',
      },
      axisLine: {
        stroke: 'gray.700',
      },
    },
    yAxis: {
      tick: {
        fill: 'gray.500',
        fontSize: '2xs',
      },
      axisLine: {
        stroke: 'gray.700',
      },
    },
    tooltip: {
      color: 'fg.subdued',
      bg: 'bg.subtle/80',
      border: 'gray/30',
      titleColor: 'primary.emphasized',
      valueColor: 'secondary.emphasized',
    },
    legend: {
      fill: 'fg.subdued',
      fontSize: 'xs',
    },
    series: {
      // bar - used in bar charts
      defaultBar: {
        fill: 'terracotta.400',
      },
      activeBar: {
        overlayFill: 'rgba(255, 255, 255, 0.2)', // Semi-transparent overlay on top of original bar
        stroke: 'rgba(255, 255, 255, 0.2)',
        strokeWidth: 8,
      },
      // dot - used in line charts
      defaultLine: {
        stroke: 'gray.400',
        strokeWidth: 1,
      },
      defaultDot: {
        fill: 'terracotta.400',
        stroke: 'none',
        strokeWidth: 0,
      },
      activeDot: {
        stroke: 'gray.200',
        strokeWidth: 3,
      },
      label: {
        position: 'center',
        fill: 'white',
        fontSize: 'xs',
        fontWeight: 'bold',
      },
    },
  },
};
